export const USER_ROLES = {
  SUPER_USER: 'SUPER_USER',
  ADMIN: 'ADMIN',
  OPS: 'OPS',
  SALES: 'SALES',
  PARTNER: 'PARTNER',
  USER: 'USER',
  FINANCE: 'FINANCE',
}
